import { render, staticRenderFns } from "./o-list-news.vue?vue&type=template&id=dae0a942"
import script from "./o-list-news.vue?vue&type=script&lang=js"
export * from "./o-list-news.vue?vue&type=script&lang=js"
import style0 from "./o-list-news.vue?vue&type=style&index=0&id=dae0a942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports